unit GiftAidValidationErrorMessages;

interface

uses
  System.SysUtils, System.Classes;

type
  TGiftAidValidationErrorMessages = class
  public
    /// <summary>
    /// Converts the CSV error string from TFullDonationRec.Error (semicolon-separated rows:
    /// FieldName,ErrorCode,Value,AutoFixed) into a short human-readable message for the user.
    /// </summary>
    class function CsvToShortMessage(const ACsvError: string): string;
  private
    class function CsvFieldErrorsToShortMessage(const ACsvFieldErrors: string): string;
    class function ErrorCodePhrase(const AErrorCode: string): string;
    class function FieldLabel(const AFieldName: string): string;
  end;

implementation

{ TGiftAidValidationErrorMessages }

class function TGiftAidValidationErrorMessages.ErrorCodePhrase(const AErrorCode: string): string;
begin
  if SameText(AErrorCode, 'Valid') then
    Result := ''
  else if SameText(AErrorCode, 'Blank') then
    Result := 'is missing'
  else if SameText(AErrorCode, 'NotBlank') then
    Result := 'should be blank'
  else if SameText(AErrorCode, 'TooShort') then
    Result := 'is too short'
  else if SameText(AErrorCode, 'TooLong') then
    Result := 'is too long'
  else if SameText(AErrorCode, 'Format') then
    Result := 'has invalid format'
  else if SameText(AErrorCode, 'OutOfRange') then
    Result := 'is out of range'
  else if SameText(AErrorCode, 'AmountZero') then
    Result := 'cannot be zero'
  else if SameText(AErrorCode, 'Duplicate') then
    Result := 'possible duplicate'
  else if SameText(AErrorCode, 'Not eligible for Gift Aid claims') then
    Result := 'is not eligible for Gift Aid claims'
  else
    Result := AErrorCode;
end;

class function TGiftAidValidationErrorMessages.FieldLabel(const AFieldName: string): string;
begin
  if SameText(AFieldName, 'PostCode') then
    Result := 'Post code'
  else if SameText(AFieldName, 'FirstName') then
    Result := 'First name'
  else if SameText(AFieldName, 'Lastname') then
    Result := 'Last name'
  else if SameText(AFieldName, 'Address') then
    Result := 'Address'
  else if SameText(AFieldName, 'Title') then
    Result := 'Title'
  else if SameText(AFieldName, 'PayDate') then
    Result := 'Donation date'
  else if SameText(AFieldName, 'Amount') then
    Result := 'Amount'
  else if SameText(AFieldName, 'DonationId') then
    Result := 'Donation ID'
  else if SameText(AFieldName, 'DonorId') then
    Result := 'Donor ID'
  else if SameText(AFieldName, 'Sponsored') then
    Result := 'Sponsored'
  else if SameText(AFieldName, 'DonationKind') then
    Result := 'Donation kind'
  else
    Result := AFieldName;
end;

class function TGiftAidValidationErrorMessages.CsvFieldErrorsToShortMessage(const ACsvFieldErrors: string): string;
var
  lRows: TArray<string>;
  lParts: TArray<string>;
  lRow, lFieldName, lErrorCode, lPhrase, lLabel: string;
  lMsg: TStringList;
  j: Integer;
begin
  Result := '';
  if ACsvFieldErrors.Trim = '' then
    Exit;

  lMsg := TStringList.Create;
  try
    lRows := ACsvFieldErrors.Split([';']);
    for lRow in lRows do
    begin
      lParts := lRow.Trim.Split([',']);
      if Length(lParts) < 2 then
        Continue;
      lFieldName := lParts[0].Trim;
      lErrorCode := lParts[1].Trim;
      if SameText(lErrorCode, 'Valid') then
        Continue;

      lPhrase := ErrorCodePhrase(lErrorCode);
      if lPhrase = '' then
        Continue;

      lLabel := FieldLabel(lFieldName);
      lMsg.Add(lLabel + ' ' + lPhrase);
    end;

    if lMsg.Count > 0 then
    begin
      Result := lMsg[0];
      for j := 1 to lMsg.Count - 1 do
        Result := Result + '; ' + lMsg[j];
    end;
  finally
    lMsg.Free;
  end;
end;

class function TGiftAidValidationErrorMessages.CsvToShortMessage(const ACsvError: string): string;
var
  lSegments: TArray<string>;
  lSegment, lPartMsg: string;
  I: Integer;
begin
  Result := '';
  if ACsvError.Trim = '' then
    Exit;

  lSegments := ACsvError.Split([' | ']);
  for I := 0 to High(lSegments) do
  begin
    lSegment := lSegments[I].Trim;
    if lSegment = '' then
      Continue;

    lPartMsg := CsvFieldErrorsToShortMessage(lSegment);
    if lPartMsg = '' then
      lPartMsg := lSegment;

    if Result = '' then
      Result := lPartMsg
    else
      Result := Result + '; ' + lPartMsg;
  end;
end;

end.
